// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { useSelector } from "react-redux";
import { Text, useDisclosure } from "@chakra-ui/react";

import { getGroup } from "src/reducers";
import MembersModal from "src/components/Modal/Members";
import { GroupTitle } from "./styles";

type GroupMembersModalProps = {
  id: number
};

const GroupMembersModal = ({ id }: GroupMembersModalProps) => {
  const { members, title } = useSelector(({ app }) => getGroup(app, id)) || {
    title: i18n.t(k._4),
    members: []
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <span>
      <Text as="span">{title}</Text>{" "}
      <Text as="span" onClick={onOpen} sx={GroupTitle}>
        {i18n.t(k._1)}
        {members.length}{" "}
        {members.length > 1 ? i18n.t(k.MEMBERS) : i18n.t(k.MEMBER)}
        {i18n.t(k._2)}
      </Text>
      <MembersModal id={id} isOpen={isOpen} onClose={onClose} />
    </span>
  );
};

export default GroupMembersModal;
